<script>
import ViewHeader from '@/components/ViewHeader.vue';
import StatCard from '@/components/StatCard.vue';
import HomeOverview from '@/components/HomeOverview.vue';
import ForecastCard from '@/components/ForecastCard.vue';

export default {
  name: 'HomeView',
  components: { ForecastCard, HomeOverview, StatCard, ViewHeader },
  props: {},
  data() {
    return {
      activeView: 'month',
      buttonOptions: [
        {
          label: 'Maand',
          value: 'month',
        },
        {
          label: 'Totaal',
          value: 'total',
        },
      ],
    };
  },
  computed: {
    subtitle() {
      return this.activeView === 'month'
        ? 'Jouw zonnerapport van deze maand'
        : 'Jouw totale zonnerapport';
    },
  },
};
</script>

<template>
  <div>
    <view-header title="Inzicht" :sub-title="subtitle"/>
    <SelectButton v-model="activeView" :options="buttonOptions" option-label="label" option-value="value" class="px-7 mt-2"/>
    <home-overview :active-view="activeView"/>
    <forecast-card class="px-7 mt-4"/>
  </div>
</template>

<style scoped>
</style>
